import React from 'react'
import classnames from 'classnames'

const LightWarningIcon: React.FC<{ className?: string }> = ({
  className = '',
}) => (
  <svg
    className={classnames('icon--light-warning-icon', {
      [className]: !!className,
    })}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M9.58785 12.8226H10.354L10.8648 8.2766V4.68408H9.14517V8.22553L9.58785 12.8226ZM8.92383 16.6024H11.0862V14.389H8.92383V16.6024Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4354 2.20623C7.90622 -0.735411 12.1041 -0.735407 13.5749 2.20623L19.5838 14.224C20.9106 16.8777 18.981 20 16.014 20H3.99625C1.02933 20 -0.900342 16.8777 0.426502 14.224L6.4354 2.20623ZM12.147 2.92018C11.2645 1.1552 8.74579 1.1552 7.8633 2.92018L1.8544 14.938C1.05829 16.5302 2.2161 18.4036 3.99625 18.4036H16.014C17.7942 18.4036 18.952 16.5302 18.1559 14.938L12.147 2.92018Z"
      fill="currentColor"
    />
  </svg>
)

export default LightWarningIcon
